import { configureStore } from "@reduxjs/toolkit";
import counterReducer from "../features/counter/counterSlice";
import customerReducer from "../features/customerData/customerDataSlice";
import notificationReducer from "../features/notifications/notificationSlice"

export default configureStore({
  reducer: {
    products: counterReducer,
    customerData: customerReducer,
    notifications: notificationReducer
  },
});
